import React from "react";
import PrepFqReportRoot from "../../../../src/views/prepFq/Report";
import Head from "next/head";
import { useTranslation } from "next-i18next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { useRouter } from "next/router";
import { useAuth } from "../../../../src/firebase/useAuth";
import useUser from "../../../../src/firebase/useUser";
import { firebaseAdmin } from "../../../../src/firebase/firebaseAdmin";
import LearningModulesProvider from "../../../../src/views/prepFq/fetchers/learning_modules/LearningModulesProvider";
import { routerPushAndScroll } from "../../../../src/utils/router";
import { DASHBOARD } from "../../../../src/constants/routes";

const PremiumDashboardPage = (props) => {
  const { t } = useTranslation(["prepFq", "profile"]);
  const router = useRouter();
  const authUser = useAuth();
  const { user } = useUser(authUser?.user?.uid);
  React.useEffect(() => {
    if (typeof window !== "undefined") {
      if (user) {
        if (user.prep_fq_status !== "completed") {
          routerPushAndScroll(router, DASHBOARD);
        }
      }
    }
  }, [router, user]);
  return (
    <React.Fragment>
      <Head>
        <title>{t(`prepFq:metaTitle.report`)}</title>
        <meta name="viewport" content="initial-scale=1.0, width=device-width" />
      </Head>
      <LearningModulesProvider
        learningModules={props.learningModules}
        allQuestions={props.allQuestions}
      >
        <PrepFqReportRoot />
      </LearningModulesProvider>
    </React.Fragment>
  );
};

export const getStaticProps = async ({ locale }) => {
  const learningModulesSnap = await firebaseAdmin
    .firestore()
    .collection("learning_modules")
    .get();
  const learningModules = [];
  learningModulesSnap.forEach((snap) => {
    learningModules.push({
      key: snap.id,
      ...snap.data(),
    });
  });
  const questionsSnap = await firebaseAdmin
    .firestore()
    .collection("prep_fq_quiz")
    .doc("prep_fq_quiz")
    .collection("questions")
    .get();
  const questions = [];
  questionsSnap.forEach((snap) => {
    questions.push({
      key: snap.id,
      ...snap.data(),
    });
  });
  return {
    props: {
      ...(await serverSideTranslations(locale, [
        "common",
        "prepFq",
        "footer",
        "header",
      ])),
      learningModules,
      allQuestions: questions,
    },
  };
};

export default PremiumDashboardPage;
